import { render, staticRenderFns } from "./OutPatientCare.vue?vue&type=template&id=20308668&scoped=true"
import script from "./OutPatientCare.vue?vue&type=script&lang=js"
export * from "./OutPatientCare.vue?vue&type=script&lang=js"
import style0 from "./OutPatientCare.vue?vue&type=style&index=0&id=20308668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20308668",
  null
  
)

export default component.exports